export const SALE_ORIGIN_XELT = "xelt";
